import { buildMatchTypesQueryString } from "apis/customerAppraiserExclusions";

const customerInspectorExclusions = {
  add() {
    return `/CustomerInspectorExclusions`;
  },
  remove(exclusionId) {
    return `/CustomerInspectorExclusions/${exclusionId}`;
  },
  getCustomers(inspectorNumber) {
    return `/CustomerInspectorExclusions/inspectors/${inspectorNumber}`;
  },
  getInspectors(customerNumber) {
    return `/CustomerInspectorExclusions/customers/${customerNumber}`;
  },
  findInspectors(customerNumber, matchTypesArray) {
    return `/CustomerInspectorExclusions/customers/${customerNumber}/search?${buildMatchTypesQueryString(matchTypesArray)}`;
  },
};

export default customerInspectorExclusions;